import React from 'react'

interface ImageAttachmentCardProps {
  attachment: {
    id: string
    url: string
    filename?: string
    mime_type?: string
  }
  setSelectedImage: (image: { url: string; filename?: string }) => void
}

const ImageAttachmentCard: React.FC<ImageAttachmentCardProps> = ({
  attachment,
  setSelectedImage,
}) => {
  return (
    <div className="position-relative">
      <img
        src={attachment.url}
        alt={attachment.filename || ''}
        className="img-fluid rounded-xl"
        style={{
          maxWidth: '320px',
          maxHeight: '384px',
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          borderRadius: '24px',
        }}
        onClick={() =>
          setSelectedImage({
            url: attachment.url,
            filename: attachment.filename,
          })
        }
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.02)'
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
        }}
        loading="lazy"
      />
      {attachment.filename && (
        <div
          className="position-absolute bottom-0 start-0 px-2 py-1 d-flex align-items-center"
          style={{
            background:
              'linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.6))',
            color: 'white',
            fontSize: '10px',

            backdropFilter: 'blur(4px)',
          }}
        >
          <ion-icon
            name="image"
            style={{ marginRight: '4px', fontSize: '12px' }}
          />
          <span className="text-truncate" style={{ maxWidth: '200px' }}>
            {attachment.filename}
          </span>
        </div>
      )}
    </div>
  )
}

export default ImageAttachmentCard
